// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {InteractionTool} from './interaction-tool.js'
import {Point} from './point.js'
import {TextSelection} from './text-selection.js'

export class PeerInteraction {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PeerInteraction {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPeerInteraction(bb: flatbuffers.ByteBuffer, obj?: PeerInteraction): PeerInteraction {
    return (obj || new PeerInteraction()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPeerInteraction(bb: flatbuffers.ByteBuffer, obj?: PeerInteraction): PeerInteraction {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PeerInteraction()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  cursorPosition(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  selectedEntities(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  selectedEntitiesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  tool(): InteractionTool {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : InteractionTool.Pointer
  }

  textSelection(obj?: TextSelection): TextSelection | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? (obj || new TextSelection()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  recordingInProgress(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  static startPeerInteraction(builder: flatbuffers.Builder) {
    builder.startObject(7)
  }

  static addCursorPosition(builder: flatbuffers.Builder, cursorPositionOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, cursorPositionOffset, 0)
  }

  static addSelectedEntities(builder: flatbuffers.Builder, selectedEntitiesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, selectedEntitiesOffset, 0)
  }

  static startSelectedEntitiesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static addTool(builder: flatbuffers.Builder, tool: InteractionTool) {
    builder.addFieldInt8(4, tool, InteractionTool.Pointer)
  }

  static addTextSelection(builder: flatbuffers.Builder, textSelectionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, textSelectionOffset, 0)
  }

  static addRecordingInProgress(builder: flatbuffers.Builder, recordingInProgress: boolean) {
    builder.addFieldInt8(6, +recordingInProgress, +false)
  }

  static endPeerInteraction(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    return offset
  }
}
